import * as M from "@discovery/prelude/lib/data/maybe";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { Fold, Lens, Getter } from "@discovery/prelude/lib/control/lens";
export const _TotalPages = Fold.compose(Res._Response(), Lens.prop("meta"), M._Just(), Lens.prop("totalPages"), M._Just());
export const _Response2ResponseData = () => Fold.map((res) => Res.map((x) => x.data, res), Getter.of());

